const errorMessageToDisplay = (error) => {
    if (error && error.message) {
        return error.message; // Return the specific error message if available
    }
    return "Error calling API. If the problem persists, please contact the support team at Investment.Data.Platform.Support@mandg.com.";
};

export default errorMessageToDisplay;
